import axios from "axios";

const API_BASE = import.meta.env.VITE_API_GATEWAY_URL || "http://localhost:8000";

export async function getVehicleAlerts(vehicleId: string) {
  const res = await axios.get(
    `${API_BASE}/api/war-room/alerts/${vehicleId}`
  );
  return res.data;
}
